module.exports = __webpack_public_path__ + "img/2024-22.cfa73585.jpg";